import { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { tss } from "tss-react";
import { Menu, Input, InputAdornment } from "@mui/material";
import EventsEmitter from "events/EventsEmitter";
import { ArrowDropDown } from "@mui/icons-material";

const hoverColor = "#02578E";

const useStyles = tss.create({
    customSelecteRoot: {
        width: "100%",
    },
    input: {
        textAlign: "left",
        " & input": {
            cursor: "pointer",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        },
    },
    menu: {
        "& div": {
            overflow: "hidden",
        },
    },
});

type IProps = {
    value: any;
    children: any;
    className?: any;
    style?: any;
    inputProps?: any;
    menuListProps?: any;
    menuMaxHeight?: number;
    disableClose?: boolean;
    disableUnderline?: boolean;
};

export default function CustomSelect(props: IProps) {
    var { classes, cx } = useStyles();
    var {
        value,
        className,
        style,
        children,
        inputProps,
        menuListProps,
        menuMaxHeight,
        disableClose,
        disableUnderline,
    } = props;
    var [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const closeMenu = () => {
            setAnchorEl(null);
        };
        EventsEmitter.on("closeMenu", closeMenu);
        return () => {
            EventsEmitter.removeEventListener("closeMenu", closeMenu);
        };
    }, []);

    const handleMenu = (evt: any) => {
        setAnchorEl(evt.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClick = (evt: any) => {
        if (!disableClose) {
            handleClose();
        }
    };

    return (
        <div className={classes.customSelecteRoot} style={style}>
            <Input
                value={value}
                onClick={handleMenu}
                className={cx(className, classes.input)}
                style={style}
                inputProps={inputProps}
                disableUnderline={disableUnderline}
                endAdornment={
                    <InputAdornment position="end">
                        <ArrowDropDown fontSize="small" />
                    </InputAdornment>
                }
                spellCheck={false}
            />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                MenuListProps={menuListProps}
                className={classes.menu}
                onClick={onClick}
            >
                <Scrollbars
                    autoHeight
                    autoHeightMax={menuMaxHeight ? menuMaxHeight : 180}
                    style={{ overflowX: "hidden", width: "100%," }}
                >
                    {children}
                </Scrollbars>
            </Menu>
        </div>
    );
}
